const binding = { modules: {}, dataActions: {} };

    (binding.modules['price-visualization'] = {
        c: () => require('partner/modules/price-visualization/price-visualization.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'price-visualization',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/price-visualization'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|price-visualization|price-visualization'] = {
                c: () => require('partner/modules/price-visualization/price-visualization.view.tsx'),
                cn: '__local__-__local__-price-visualization'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };